import React, { useState } from "react";
import { useTheme } from "../../../../../hooks";
import { Icon } from "../../../../icon";
import { NavItemContentContainer, NavItemName } from "./NavItemStyles";
const NavItemContent = ({ id, onClick, icon, iconCategory, displayName = true, name, active, className = "", isVertical = false, }) => {
    const { Theme } = useTheme();
    const [hovered, setHovered] = useState(false);
    return (React.createElement(NavItemContentContainer, { id: id, className: className, onClick: !!onClick ? onClick : undefined, onMouseOver: () => setHovered(true), onMouseLeave: () => setHovered(false) },
        !!icon && (React.createElement(Icon, { iconName: icon, iconCategory: iconCategory, styles: {
                color: hovered
                    ? Theme.nav[isVertical ? "vertical" : "horizontal"].nav.hover.color
                    : active
                        ? Theme.nav[isVertical ? "vertical" : "horizontal"].nav.active.color
                        : Theme.nav[isVertical ? "vertical" : "horizontal"].nav.color,
                hoverColor: Theme.nav[isVertical ? "vertical" : "horizontal"].nav.hover.color,
            } })),
        displayName && React.createElement(NavItemName, null, name)));
};
export default NavItemContent;
//# sourceMappingURL=NavItemContent.js.map